module.exports = __webpack_public_path__ + "img/about_logo_29.5b5c2bb1.png";